import { render, staticRenderFns } from "./resolutionVoteDetail.vue?vue&type=template&id=d9f7f220&"
import script from "./resolutionVoteDetail.vue?vue&type=script&lang=js&"
export * from "./resolutionVoteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports